import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import NonPatientActivityEdit from '../../features/NonPatientActivities/Edit/NonPatientActivityEdit';
import globals from '../../globals/communityGlobals';
import { checkFeatureAccess } from '../../utils/helpers';
import { updateNonPatientActivity, getNonPatientActivity } from '../../actions/entities';
import { dismissError } from '../../actions/entities/nonPatientActivities';

const mapStateToProps = ({ global: { auth }, entities: { nonPatientActivities } }) => {
  const access = auth.featureAccessList;
  return {
    access,
    canEditTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canTriggerSync),
    isFetching: nonPatientActivities.previewed.isFetching,
    isAssigning: nonPatientActivities.assigned.isAssigning,
    nonPatientActivity: nonPatientActivities.previewed.nonPatientActivity,
    failureMessage: nonPatientActivities.npaMessages.failure,
  };
};

const mapDispatchToProps = dispatch => ({
  navigate: url => dispatch(push(url)),
  goBack: () => dispatch(goBack()),
  getNonPatientActivityData: async id => {
    try {
      await dispatch(getNonPatientActivity(id));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('errorPage', error);
    }
  },
  submitAction: async nonPatientActivity => await dispatch(updateNonPatientActivity(nonPatientActivity)),
  dismissError: () => dispatch(dismissError()),
});

const NonPatientActivityEditContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NonPatientActivityEdit);

export default NonPatientActivityEditContainer;
